
webpack.register(
    'modules/viewing-schedule/viewing-schedule',
    function() {
        return import('modules/viewing-schedule/viewing-schedule');
    },
    true
);